export const headTitle = ['Генетика', 'Внешность', 'Растительность', 'Макияж'];
